import React, { FC, ReactNode } from 'react'

import Snackbar from 'components_new/atoms/Snackbar'
import Stack from 'components_new/atoms/Stack'
import Link from 'components_new/atoms/Link'

import { useSnackbar } from 'redux/hooks/Snackbar'
import { useSnackbarActions } from 'redux/actions/Snackbar'
import { useTranslation } from 'language/translator'

interface SnackbarWrapperProps {
  // Snackbars stacked above the global one, each with position static.
  children?: ReactNode
}

const SnackbarWrapper: FC<SnackbarWrapperProps> = ({ children }) => {
  const snackbar = useSnackbar()
  const { toggleSnackbarClosed } = useSnackbarActions()
  const { translateEnum } = useTranslation()

  return (
    <Stack
      direction="column"
      sx={{
        bottom: { xs: 8, sm: 24 },
        gap: 1,
        left: { xs: 8, sm: 24 },
        position: 'fixed',
        right: { xs: 8, sm: 'auto' },
        zIndex: 'snackbar'
      }}
    >
      {children}
      <Snackbar
        open={snackbar.open}
        message={
          snackbar.message
            ? translateEnum('snackbar_messages', snackbar.message)
            : undefined
        }
        onClose={() => toggleSnackbarClosed()}
        autoHideDuration={snackbar.options?.duration ?? 3000}
        action={
          snackbar.options?.link ? (
            <Link color="brand.light" onClick={snackbar.options.link.link}>
              {translateEnum('snackbar_link_texts', snackbar.options.link.text)}
            </Link>
          ) : undefined
        }
        sx={{ position: 'static' }}
      />
    </Stack>
  )
}

export default SnackbarWrapper
